var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupHolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M7.702 2.351L.275 20.723a3.79 3.79 0 003.517 5.207h14.833a3.79 3.79 0 003.507-5.21L14.715 2.35a3.79 3.79 0 00-7.013 0zm13.143 17.533a3.79 3.79 0 01-3.507 5.211 3.79 3.79 0 01-3.506-5.21 3.79 3.79 0 017.006.013l.007-.014zM11.377 9.86h-.35a3.79 3.79 0 01-3.518-5.173l.175-.441a3.79 3.79 0 017.049 0l.175.441a3.79 3.79 0 01-3.524 5.187l-.007-.014zM1.47 19.899l.106-.26a3.79 3.79 0 017.013 0l.105.26a3.79 3.79 0 01-3.506 5.21H4.98a3.79 3.79 0 01-3.51-5.21z"
  })));
}
export default SvgCupHolder;